<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="筛选基地：" label-for="key">
              <Select v-model="filter.land_base_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in landBaseList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="报告类型：" label-for="key">
              <Select v-model="filter.category" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option :value="1">周报</Option>
                <Option :value="2">月报</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import {landBaseReportTextListApi} from '@/api/landBase/landBaseReportText'
import {landBaseAllApi} from '@/api/landBase/landBase'

export default {
  name: 'landBaseReportTextList',
  inject: ['reload'],
  data() {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      landBaseList: [],
      filter: {
        page: 1,
        limit: 10,
        land_base_id: 0,
        category: 0,
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '所属基地',
          key: 'land_base_name',
          minWidth: 120
        },
        {
          title: '报告类型',
          key: 'category_msg',
          minWidth: 100
        },
        {
          title: '文本模版类型(位置)',
          key: 'type_msg',
          minWidth: 200
        },
        {
          title: '最后修改时间',
          key: 'mtime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 80
        }
      ]
    }
  },
  created() {
    this.restoreFilter()
    this.loadLandBaseData()
    this.loadTableData()
  },
  methods: {
    // 加载表格数据
    loadTableData() {
      this.loading = true
      landBaseReportTextListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 下拉选择
    select() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 编辑
    edit(id) {
      this.$router.push({path: this.pathFormat(this.$route.path, 'edit', id)})
    },
    // 所有基地
    loadLandBaseData() {
      landBaseAllApi().then(res => {
        if (res.code === 200) {
          this.landBaseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 恢复筛选项
    restoreFilter() {
      const savedFilter = sessionStorage.getItem('landBaseReportTextListFilter')
      if (savedFilter) {
        this.filter = JSON.parse(savedFilter)
      }
    },
    // 保存筛选项
    saveFilter() {
      sessionStorage.setItem('landBaseReportTextListFilter', JSON.stringify(this.filter))
    }
  },
  beforeRouteLeave(to, from, next) {
    this.saveFilter() // 保存筛选条件
    next()
  }
}
</script>
